import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import { IPagedResult } from '../../shared/models/paged-result';
import { Budget } from '../../shared/models/sale/budget.model';

export const budgetApi = createApi({
  reducerPath: 'budgetApi',
  baseQuery,
  endpoints: (builder) => ({
    budgetList: builder.query<IPagedResult<Budget>, string>({
      query: (params) => ({
        url: `/api/budgets?${params}`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useLazyBudgetListQuery } = budgetApi;
